import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Token from "../../../assests/img/22.png";
import Cordelia from "../../../assests/img/23.png";
import Print from "../../../assests/img/24.png";
import ongc from "./images/c1.png";
import job from "../../../assests/img/image.png";
import num from "./images/num.png";
import num1 from "../../../assests/img/image (1).png";
import num2 from "../../../assests/img/image (2).png";
import num3 from "../../../assests/img/image (3).png";
import num4 from "../../../assests/img/image (4).png";
import num5 from "../../../assests/img/image (5).png";
import num6 from "../../../assests/img/image (6).png";
import git from "../../../assests/img/US.png";
import bul from "./images/bul.png";
import aimms from "./images/aiimss-new.png";
import lms from "./images/c2.png";
import help from "./images/c3.png";
import AboutImage from "../../../assests/service.png";
import bgimage from "../../../assests/webiconF (3)/1.png";

const projects = [
  {
    name: "Printoffice",
    description:
      "From Business Cards to T-shirts, personalize all products using our Design Studio",
    description1: "",
    image: Print,
    domain: "https://www.printoffice.com/",
    technologies: ["Moment.js", "jQuery", "FancyBox", "Bootrap"],
  },
  {
    name: "Token Money Magnet",
    description:
      "Tokenization is the process of converting the rights of real-world assets into digital tokens on blockchain technology..",
    description1: "",
    image: Token,
    domain: "https://token-money-three.vercel.app/home",
    technologies: ["React.js", "Tailwind.css"],
  },
  {
    name: "Cordelia Cruises",
    description:
      " Discover the breathtaking beauty of both Domestic and International destinations with Cordelia Cruises.",
    description1: "",
    image: Cordelia,
    domain: "https://www.cordeliacruises.com/",
    technologies: ["React.js", "R R", "Tailwind.css"],
  },
  {
    name: "ONGC",
    description:
      " ONGC, India's government-owned oil and gas giant, has multiple centers with various fire extinguishers installed. Managing and tracking their maintenance was time-consuming and labor-intensive.",
    description1: "",
    image: ongc,
    domain: "",
    technologies: ["React.js", "Java", "React Native"],
  },
  {
    name: "Ledger Management System",
    description:
      "Municipal Corporations in India manage urban services and handle large-scale financial transactions daily. Maintaining accurate records and managing accounts is often complex and time-consuming.",
    description1: "",
    image: lms,
    domain: "",
    technologies: ["React.js", "Dot net"],
  },
  {
    name: "Helpdesk",
    description:
      "Municipal Corporations manage urban services like healthcare, housing, and transport. However, tracking service quality and status remains a major challenge due to the lack of monitoring mechanisms.",
    description1: "",
    image: help,
    domain: "",
    technologies: ["React.js", "Dot net"],
  },
  {
    name: "AIIMS",
    description:
      "AIIMS, a premier medical institution in India, focuses on training future medical educators. Managing and tracking faculty recruitment applications was a major challenge due to the institute's high-volume operations.",
    description1: "",
    image: aimms,
    domain: "",
    technologies: ["PHP", "CI"],
  },
  {
    name: "Jobanzeige 24",
    description:
      "Jobanzeige24 is a Swiss job portal connecting employers and job seekers across various industries. It offers a user-friendly platform to post, search, and apply for jobs efficiently.",
    description1: "",
    image: job,
    domain: "",
    technologies: ["PHP", "Bootstrap"],
  },
  {
    name: "Bhoomi Infra",
    description:
      "Their corporate website, built using WordPress, showcases property listings, company portfolio, and contact features, ensuring easy navigation and an elegant user experience.",
    description1: "",
    image: bul,
    domain: "",
    technologies: ["wordpress"],
  },
  {
    name: "Getit",
    description:
      "From Kirana to KitchenGetit Connecting You to Local Stores, Instantly–",
    description1: "",
    image: git,
    domain: "",
    technologies: ["React Native"],
  },
  {
    name: "Numetric work",
    description:
      "Numertic is accounting software for Small businesses that works as hard as you do Create Professional Invoices, manage expenses, send payments links, and dynamic dashboard. All you need for your growing business.",
    description1: "",
    image: num,
    domain: "",
    technologies: ["Angular", "TypeScript", "Node.js", "Nginx"],
  },

  {
    name: "Total Transport Systems Limited (TTSL)",
    description:
      "Total Transport Systems Limited is a leading logistics company specializing in cargo consolidation and deconsolidation across Indian and international markets. With robust infrastructure and a skilled team, TTSL ensures timely and efficient global freight solutions.",
    description1: "",
    image: num1,
    domain: "",
    // technologies: ["Angular", "TypeScript", "Node.js", "Nginx"]
  },
  {
    name: "Rajawat Group – Your Trusted Facility Management Partner",
    description:
      "Rajawat Group provides professional facility management and support services with a trained workforce across multiple sectors.",
    description1:
      " With 1.5k+ satisfied clients and 500+ staff, they ensure reliability, hygiene, and excellence in every service delivered.",
    image: num2,
    domain: "",
    // technologies: ["Angular", "TypeScript", "Node.js", "Nginx"]
  },
  {
    name: "ARMAF – Luxury French Fragrances",
    description:
      "Discover premium French perfumes, deodorants, and body mists from ARMAF, now available with nationwide delivery. .",
    description1:
      "Enjoy authentic fragrances with guaranteed quality, exclusive imports, and free shipping on prepaid orders",
    image: num3,
    domain: "",
    // technologies: ["Angular", "TypeScript", "Node.js", "Nginx"]
  },
  // {
  //   name: "Pitreshwar – Trendy Apparel for Every Style",
  //   description: "Explore a vibrant collection of Indian and Western wear with stylish designs for every occasion.",
  //   description1: "Enjoy great deals, multiple size options, and easy online shopping with fast shipping and secure payments.",
  //   image: num4,
  //   domain: "",
  // },
  {
    name: "Tek Blood Bank – Lifesaving Made Simple",
    description:
      "A user-friendly platform to request, donate, and manage blood needs instantly.",
    description1:
      "Track requests, connect with donors, and stay updated on blood donation events effortlessly",
    image: num5,
    domain: "",
    // technologies: ["Angular", "TypeScript", "Node.js", "Nginx"]
  },
  {
    name: "TEK AMS – Smart Attendance & Productivity Monitoring",
    description:
      "An intelligent Attendance Management System that tracks punch-ins, punch-outs, and work hours with location accuracy.",
    description1:
      "Gain real-time insights into employee productivity, time usage, and task efficiency with a user-friendly interface.",
    image: num6,
    domain: "",
    // technologies: ["Angular", "TypeScript", "Node.js", "Nginx"]
  },
];
const Portfolio = () => {
  const [expandedProject, setExpandedProject] = useState(null);

  const toggleProject = (projectName) => {
    setExpandedProject((prev) => (prev === projectName ? null : projectName));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="">
      <Helmet>
        <title>Our Portfolio | Showcase of Projects & Success Stories</title>
        <meta
          name="description"
          content="Explore our portfolio to see a diverse range of successful projects. Discover our expertise and the impactful solutions we’ve delivered across various industries."
        />
        <meta
          name="keywords"
          content="Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Executive Staffing, Staffing Company, staffing services"
        />
        <link rel="canonical" href="https://www.tekitsolution.com/portfolio" />
      </Helmet>
      <div className="relative w-full h-[400px] overflow-hidden">
        {/* ✅ LCP-optimized image */}
        <img
          src={AboutImage}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
          fetchpriority="high"
        />

        {/* ✅ Overlay content */}
        <div className="absolute top-40 w-full h-full z-10 flex flex-col items-center justify-start">
          <img src={bgimage} alt="Overlay icon" className="w-20 mb-4" />
          <h1 className="text-center lg:text-[46px] text-[46px] font-bold text-black">
            Crafted with Vision. Powered by Passion
          </h1>
        </div>
      </div>

      {/* Projects Grid */}
      <div className="container mx-auto px-4 py-12 font-recoleta">
        <div className="text-center">
          <h1 className="text-[48px] 2xl:text-[32px] lg:text-[26px]">
            OUR PROJECTS
          </h1>
        </div>
        <div className="grid grid-cols-1  lg:grid-cols-3 gap-8 mt-14">
          {projects.map((project) => (
            <div
              key={project.name}
              className="bg-white shadow-lg rounded-lg overflow-hidden cursor-pointer flex flex-col"
              onClick={() => toggleProject(project.name)}
            >
              {/* Image section */}
              <div className="h-full w-full">
                <img
                  src={project.image}
                  alt={project.name}
                  className="w-full p-0 lg:h-44 2xl:60 object-cover"
                />
              </div>
              {/* Content section */}
              <div className="p-4 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="2xl:text-[26px]  lg:text-[20px] text-[34px] font-bold mb-2">
                    {project.name}
                  </h3>
                  <p className="text-gray-700 mb-2 text-[24px] 2xl:text-[20] lg:text-[16px]">
                    {project.description}
                  </p>
                  <p className="text-gray-700 mb-2 text-[24px] 2xl:text-[20] lg:text-[16px]">
                    {project.description1}
                  </p>
                  <p className="2xl:text-[24px]  lg:text-[20px] text-[28px] text-gray-500 mb-2">
                    {/* <strong>Domain:</strong> {project.domain} */}
                  </p>
                </div>

                {/* Conditionally show technologies */}
                {/* {expandedProject === project.name && (
                  <div className="flex flex-wrap gap-2 mt-4">
                    {project.technologies.map((tech, index) => (
                      <span
                        key={index}
                        className="2xl:text-[24px]  lg:text-[20px] text-[28px] px-2 py-1 rounded-full border border-[#09588D] bg-[#09588D] text-white"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                )} */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
